import { memo, MouseEvent, ReactNode } from 'react'
import cn from 'classnames'

import s from './ListCard.module.less'
import cs from 'src/common.module.less'

interface IProps {
  actions?: ReactNode
  additional?: ReactNode
  children?: ReactNode
  className?: string
  footer?: ReactNode
  header?: ReactNode
  onClick?: (event: MouseEvent<HTMLDivElement>) => void
  stacked?: boolean
  testId?: string
}

export const ListCard = memo<IProps>(function ListCard({
  header,
  additional,
  actions,
  className,
  children,
  footer,
  stacked = true,
  testId,
  ...props
}) {
  return (
    <div
      {...props}
      data-test-id={testId}
      className={cn(s.card, className, {
        [s.card_stacked]: stacked
      })}
    >
      {(header || actions) && (
        <div className={s.header}>
          {header && <div className={s.title}>{header}</div>}
          {(additional || actions) && (
            <div className={s.wrapper}>
              {additional && <div className={s.additional}>{additional}</div>}
              {actions && (
                <div
                  className={cn(cs.marginMinusR8, {
                    [cs.marginL16]: !!additional
                  })}
                >
                  {actions}
                </div>
              )}
            </div>
          )}
        </div>
      )}
      <div>{children}</div>
      {footer && <div>{footer}</div>}
    </div>
  )
})
